_HydrationManager